import React from "react";
import { Controls, IFormStyles, useFormStyles } from "../.";
import { FormGroup, FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormDropdownProps extends Controls.ControlDropdownProps {
    isLoading?: boolean | undefined
    label?: string | undefined
    groupType?: FormGroupType | undefined;
    labelWidth?: string | undefined;
}

const ComponentProps = (props: FormDropdownProps): Controls.ControlDropdownProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;
    delete componentProps.labelWidth;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormDropdownProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,
        isHidden: props.isHidden,
        labelWidth: props.labelWidth,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
}

export const FormDropdown: React.FC<FormDropdownProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlDropdown {...ComponentProps(props)} controlStyles={styles.control} />
        </FormGroup>
    );
};
